export type { NtpTimeResult } from "./NtpTimeResult.js";
export {
  NtpTimeSync,
  NtpTimeSyncDefaultOptions,
  type NtpTimeSyncConstructorOptions,
  type NtpTimeSyncOptions,
} from "./NtpTimeSync.js";
